import React, { useState, useEffect, useContext } from 'react';
import { useQueryParam, StringParam, BooleanParam } from 'use-query-params';

const SearchParamsContext = React.createContext<any | null>({});

const SearchParamsContextComponent = ({ children }: {children: any}) => {

    const [queryParam, setQueryParam] = useQueryParam('query', StringParam);
    const [searchOpen, setOpenParam] = useQueryParam('open', BooleanParam);

    const [isTopSearchOpen, setIsTopSearchOpenHook] = useState(!!searchOpen);
    const [topSearchText, setTopSearchTextHook] = useState(isTopSearchOpen ? queryParam : '');
    const [mainSearchText, setMainSearchTextHook] = useState(!isTopSearchOpen ? queryParam : '');

    const setIsTopSearchOpen = (open: boolean ) => {
        setIsTopSearchOpenHook(open);
        setOpenParam(open);
        if(open) {
            setQueryParam('');
        }
    }

    const setTopSearchText = (text: string) => {
        setTopSearchTextHook(text);
        setMainSearchTextHook('');
        setQueryParam(text);
        setOpenParam(true);
        setIsTopSearchOpenHook(true);
    }

    const setMainSearchText = (text: string) => {
        setMainSearchTextHook(text);
        setTopSearchTextHook('');
        setQueryParam(text);
        setOpenParam(false);
        setIsTopSearchOpenHook(false);
    }

    const value = {
        isTopSearchOpen,
        topSearchText,
        mainSearchText,
        setIsTopSearchOpen,
        setTopSearchText,
        setMainSearchText
    }

    return (
        <SearchParamsContext.Provider value={value}>
            {children}
        </SearchParamsContext.Provider>
    )

}



const useSearchParams = () => useContext(SearchParamsContext);

export {useSearchParams, SearchParamsContextComponent, SearchParamsContext};

